import { useState, useEffect, useCallback } from 'react'

import { constants } from '../../../lib/constants'
import { getPageContentListService } from '../../../lib/services/pageService'
import { Faqs as FaqsComponent } from '../../atomic/Faqs'

export const Faqs = ({ vehicleType, serverFaqList = null, title = null }) => {
  const [status, setStatus] = useState(constants.componentStatus.LOADING)
  const [faqList, setFaqList] = useState([])
  const [activeFaqs, setActiveFaqs] = useState(
    !!serverFaqList && serverFaqList.length > 0 ? [serverFaqList[0].slug] : [],
  )

  const fetchData = useCallback(
    async requestParams => {
      setStatus(constants.componentStatus.LOADING)
      try {
        const response = await getPageContentListService(requestParams)
        const list = response.items[0].content.items.filter(faq => faq.vehicleType === vehicleType)
        setFaqList(list)
        return setStatus(constants.componentStatus.COMPLETE)
      } catch (err) {
        if (err.status === 404) {
          return setStatus(constants.componentStatus.NOT_FOUND)
        } else {
          return setStatus(constants.componentStatus.ERROR)
        }
      }
    },
    [vehicleType],
  )

  useEffect(() => {
    if (serverFaqList === null) {
      const requestParams = {
        type: 'FAQ_DEAL_PAGE',
        page: '1',
      }

      fetchData(requestParams)
    } else {
      setFaqList(serverFaqList)
      setStatus(constants.componentStatus.COMPLETE)
    }
  }, [vehicleType, serverFaqList, fetchData])

  useEffect(() => {
    if (faqList.length > 0) {
      setActiveFaqs([faqList[0].slug])
    }
  }, [faqList])
  return (
    <FaqsComponent
      vehicleType={vehicleType}
      status={status}
      faqList={faqList}
      activeFaqs={activeFaqs}
      setActiveFaqs={setActiveFaqs}
      title={title !== null ? title : 'In case you missed anything.'}
    />
  )
}
